import api from './axios';

export const slackService = {
  // Search documents via Slack API
  async searchDocuments(searchTerm, documentType, channelId) {
    const response = await api.post('/slack/api/search', {
      searchTerm,
      documentType,
      channelId
    });
    return response.data;
  },

  // List recent documents via Slack API
  async listDocuments(documentType, channelId, limit) {
    const response = await api.post('/slack/api/list', {
      documentType,
      channelId,
      limit
    });
    return response.data;
  },



  // Link Slack user to Velox user
  async linkUser(slackUserId) {
    const response = await api.post('/slack/link-user', {
      slackUserId
    });
    return response.data;
  },

  // Unlink Slack user from Velox user
  async unlinkUser() {
    const response = await api.post('/slack/unlink-user');
    return response.data;
  },

  // Get Slack user link status
  async getUserStatus() {
    const response = await api.get('/slack/user-status');
    return response.data;
  },

  // Get Slack channels (for Agent V integration)
  async getChannels() {
    const response = await api.get('/slack/channels');
    return response.data;
  },

  // Send message to Slack (for Agent V integration)
  async sendMessage(channelId, message) {
    const response = await api.post('/slack/send-message', {
      channelId,
      message
    });
    return response.data;
  }
}; 